import app from '../app';
import Component from '../Component';
import Icon from './Icon';
import MultiSelect from './MultiSelect';
import classList from '../utils/classList';
import withAttr from '../utils/withAttr';
/**
 * Picks one or more groups by name, as a standard select (or a MultiSelect
 * with `multiple`), so it looks like every other choice in a form.
 *
 * ```tsx
 * <GroupSelector value={this.groupId} onchange={(id) => (this.groupId = id)} exclude={[Group.GUEST_ID]} />
 * ```
 */
export default class GroupSelector extends Component {
  view(vnode) {
    const {
      className,
      multiple,
      value,
      onchange,
      id,
      placeholder,
      'aria-label': ariaLabel
    } = this.attrs;
    const groups = this.groups();
    if (multiple) {
      return m(MultiSelect, {
        className: classList('GroupSelector', className),
        id: id,
        "aria-label": ariaLabel,
        options: Object.fromEntries(groups.map(group => [group.id(), group.namePlural()])),
        value: Array.isArray(value) ? value : [],
        onchange: onchange
      });
    }
    const selected = groups.some(group => group.id() === value) ? value : '';

    // Select's options are an object, whose integer-like keys (group ids) can't
    // hold the groups' own order or a placeholder ahead of them, so this is its
    // markup with the options as a list.
    return m("span", {
      className: classList('Select GroupSelector', className)
    }, m("select", {
      className: "Select-input FormControl",
      id: id,
      "aria-label": ariaLabel,
      value: selected,
      onchange: withAttr('value', onchange)
    }, !selected && m("option", {
      value: "",
      disabled: true
    }, placeholder ?? app.translator.trans('core.lib.group_selector.placeholder', {}, true)), groups.map(group => m("option", {
      value: group.id()
    }, group.namePlural()))), m(Icon, {
      name: "fas fa-sort",
      className: "Select-caret"
    }));
  }
  groups() {
    const exclude = this.attrs.exclude ?? [];
    return (this.attrs.groups ?? app.store.all('groups')).filter(group => !exclude.includes(group.id()));
  }
}
flarum.reg.add('core', 'common/components/GroupSelector', GroupSelector);